module.exports = __webpack_public_path__ + "static/media/sms.c70f0454.svg";